module.exports = {};



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_iterators.js
// module id = 789
// module chunks = 32